import React from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import { TotemPopup } from 'components/TotemPopup';
import { TotemPrimaryLoadingButton } from 'components/TotemPrimaryLoadingButton';

import { totemClosedDayRemovedHandler } from '../cacheHandlers/totemClosedDayCacheHandler';

import { useAbortTotemClosedDayMutation, TotemClosedDayFragmentFragment } from 'data/__generated__';

export function AbortTotemClosedDayPopup({
    isOpen,
    setIsOpen,
    totemClosedDay,
}: {
    isOpen: boolean;
    setIsOpen: (arg: boolean) => void;
    totemClosedDay: TotemClosedDayFragmentFragment;
}) {
    const [abortTotemClosedDay, { loading }] = useAbortTotemClosedDayMutation();

    async function handleSubmit() {
        const { data } = await abortTotemClosedDay({
            variables: {
                totemClosedDayId: totemClosedDay._id,
            },
        });

        if (!data) {
            throw new Error('Une erreur est survenue lors de la création du jour de fermeture');
        }

        const { abortTotemClosedDay: abortedTotemClosedDay } = data;

        if (abortedTotemClosedDay) {
            totemClosedDayRemovedHandler(abortedTotemClosedDay._id);
            toast.success('Jour de fermeture annulé');
            setIsOpen(false);
        } else {
            toast.error('Une erreur est survenue');
        }
    }

    return (
        <TotemPopup
            title="Annuler un jour de fermeture"
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            contentOverflow="visible"
        >
            <WarningMessage>
                Attention, supprimer un jour férié des jours de fermetures Totem ne le retire pas automatiquement des
                sites. Il faut le faire à la main ou faire un tech support.
            </WarningMessage>
            <SubmitContainer>
                <TotemPrimaryLoadingButton
                    loading={loading}
                    onClick={handleSubmit}
                    useIcon={false}
                    label="Annuler le jour de fermeture"
                />
            </SubmitContainer>
        </TotemPopup>
    );
}

const SubmitContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 15px;
`;

const WarningMessage = styled.div`
    color: ${({ theme }) => theme.warningColor};
`;
